export let countries = [
    { text: "Indonesia", value: "ID" }
]